import type { CartLine } from "@/types/order";

type KeyableLine = Pick<
  CartLine,
  "dishId" | "size" | "toppings" | "extraNote" | "isReward"
>;

/**
 * Merge key for cart lines: same dish, size, toppings and note is the same line.
 *
 * Toppings are sorted so selection order is irrelevant. This is deliberately
 * NOT `groupDishes`, whose JSON.stringify key is order-sensitive and includes
 * translations — that one collapses the server's per-unit bill rows and stays
 * as it is.
 */
export const cartLineKey = (line: KeyableLine): string =>
  [
    line.dishId,
    line.size?.id ?? "",
    line.toppings
      .map((topping) => `${topping.id}x${topping.quantity}`)
      .sort()
      .join(","),
    (line.extraNote ?? "").trim(),
    // Kept apart from a paid line of the same dish: one is free, the other is
    // not, and merging them would silently reprice both.
    line.isReward ? "reward" : "",
  ].join("|");
